// extracted by mini-css-extract-plugin
export default {"cls1":"gizaPt8sZFx9wPwH8InJ","cls2":"EBpYf3KJjqfZyM1b_ptD gizaPt8sZFx9wPwH8InJ","bookingAppRedesign":"dJwVEEyFSDjMveHUhhSb"};